import { Route, Routes } from 'react-router-dom';
import BikeleasingLearnMorePage from './BikeleasingLearnMorePage';
import { BikeleasingV2ContractDetailsPage } from './BikeleasingV2ContractDetailsPage';
import { BikeleasingV2InfoPage } from './BikeleasingV2InfoPage';
import { BikeleasingV2Page } from './BikeleasingV2Page';

export const BikeleasingV2Routes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<BikeleasingV2Page />} />
      <Route path="/info" element={<BikeleasingV2InfoPage />} />
      <Route path="/learnmore" element={<BikeleasingLearnMorePage />} />
      <Route path="/contracts/:contractId" element={<BikeleasingV2ContractDetailsPage />} />
    </Routes>
  );
};
